import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solution1',
  templateUrl: './solution1.component.html',
  styleUrls: ['./solution1.component.scss']
})
export class Solution1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
